import React from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/uiKit/atoms/Button.tsx";
import { Progress } from "@/utils/ProgressMixin";

export type DeviceUploadActionProps = {
  onUpload: () => void;
  onCancel: () => void;
  progress: Progress | undefined;
  canUpload: boolean;
};

export const DeviceUploadAction: React.FC<DeviceUploadActionProps> = ({ progress, onUpload, onCancel, canUpload }) => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        disabled={!canUpload}
        variant="contained"
        pending={!!progress}
        progress={progress?.progress}
        onClick={canUpload ? onUpload : undefined}
      >
        {t("devices.upload")}
      </Button>
      {progress && (
        <Button variant="outlined" onClick={onCancel}>
          {t("devices.cancel")}
        </Button>
      )}
    </>
  );
};
